/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Save_HeadingInputs */

const en_us2_auth_save_heading = /** @type {(inputs: Auth_Save_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just your email left`)
};

const pt_br2_auth_save_heading = /** @type {(inputs: Auth_Save_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falta só o seu e-mail`)
};

const es_419_auth_save_heading = /** @type {(inputs: Auth_Save_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo falta tu email`)
};

const pt_pt2_auth_save_heading = /** @type {(inputs: Auth_Save_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só falta o teu e-mail`)
};

const fr_fr2_auth_save_heading = /** @type {(inputs: Auth_Save_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il ne manque que ton e-mail`)
};

const de_de2_auth_save_heading = /** @type {(inputs: Auth_Save_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur noch deine E-Mail`)
};

const it_it2_auth_save_heading = /** @type {(inputs: Auth_Save_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manca solo la tua email`)
};

/**
* | output |
* | --- |
* | "Just your email left" |
*
* @param {Auth_Save_HeadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_save_heading = /** @type {((inputs?: Auth_Save_HeadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Save_HeadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_save_heading(inputs)
	if (locale === "es-419") return es_419_auth_save_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_save_heading(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_save_heading(inputs)
	if (locale === "de-DE") return de_de2_auth_save_heading(inputs)
	if (locale === "it-IT") return it_it2_auth_save_heading(inputs)
	return en_us2_auth_save_heading(inputs)
});
export { auth_save_heading as "auth.save_heading" }